export default __webpack_public_path__ + "static/media/151-wheel-chair.0b6600d6.png";